/* ============================================
   QUOTE WORKSTATION — ECORE E-Cleaner Prompt
   Asset: workstation-ecore-prompt.js
   On Save: if quote has ECORE flooring but no E-Cleaner (TRD-000067),
   prompt the rep to add 1-3 bottles based on total ECORE quantity.
   ============================================ */
(function() {
  'use strict';
  var Q = window.QWS;
  if (!Q) return;
  var state = Q.state;
  var wrap = Q.wrap;

  var ECLEANER_SKU = 'TRD-000067';

  function bottleCount(sqft) {
    if (sqft >= 5000) return 3;
    if (sqft >= 3000) return 2;
    return 1;
  }

  function getECoreTotal() {
    var total = 0;
    for (var i = 0; i < state.items.length; i++) {
      var it = state.items[i];
      if ((it.vendor || '').toUpperCase() === 'ECORE') {
        total += parseFloat(it.quantity) || 0;
      }
    }
    return total;
  }

  function hasECleaner() {
    for (var i = 0; i < state.items.length; i++) {
      if ((state.items[i].sku || '').toUpperCase() === ECLEANER_SKU) return true;
    }
    return false;
  }

  function findECleanerProduct() {
    var catalog = Q.catalog || [];
    for (var i = 0; i < catalog.length; i++) {
      var cp = catalog[i];
      if ((cp.fk || '').toUpperCase() === ECLEANER_SKU) return cp;
      if (cp.vs) {
        for (var j = 0; j < cp.vs.length; j++) {
          if ((cp.vs[j].sk || '').toUpperCase() === ECLEANER_SKU) return cp;
        }
      }
    }
    return null;
  }

  function addECleaner(qty) {
    var cp = findECleanerProduct();
    if (!cp || !cp.vs || !cp.vs.length) return false;
    var v = cp.vs[0];
    for (var j = 0; j < cp.vs.length; j++) {
      if ((cp.vs[j].sk || '').toUpperCase() === ECLEANER_SKU) { v = cp.vs[j]; break; }
    }
    var vid = v.id;
    if (vid && vid.indexOf('gid://') === -1) vid = 'gid://shopify/ProductVariant/' + vid;
    var cost = parseFloat(v.c) || parseFloat(cp.fc) || 0;
    var map = parseFloat(v.p) || parseFloat(cp.fp) || 0;
    var msrp = parseFloat(v.cp) || parseFloat(cp.fcp) || 0;
    var item = {
      type: 'product',
      variantId: vid,
      vendor: cp.v || 'ECORE',
      title: cp.t || 'E-Cleaner',
      sku: v.sk || ECLEANER_SKU,
      quantity: qty,
      msrp: msrp,
      cost: cost,
      mapPrice: map,
      productHandle: cp.h || null,
      subDescriptions: []
    };
    if (cost > 0 && map > 0 && Q.autoPoints) {
      item.points = Q.autoPoints(cost, map);
      item.directPrice = map;
    }
    Q.addItem(item);
    return true;
  }

  /* ── Modal ── */
  var modal = null;

  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'rq-ws-ecleaner-prompt';
    modal.style.display = 'none';
    modal.innerHTML =
      '<div class="rq-ws-ecleaner-prompt__backdrop"></div>' +
      '<div class="rq-ws-ecleaner-prompt__dialog">' +
        '<div class="rq-ws-ecleaner-prompt__header">' +
          '<h3 class="rq-ws-ecleaner-prompt__title">Add E-Cleaner?</h3>' +
        '</div>' +
        '<div class="rq-ws-ecleaner-prompt__body">' +
          '<p class="rq-ws-ecleaner-prompt__msg"></p>' +
          '<p class="rq-ws-ecleaner-prompt__hint">Recommended for every ECORE flooring order.</p>' +
        '</div>' +
        '<div class="rq-ws-ecleaner-prompt__footer">' +
          '<button class="rep-quote-btn rep-quote-btn--secondary rq-ws-ecleaner-prompt__skip" type="button">No, save without it</button>' +
          '<button class="rep-quote-btn rep-quote-btn--primary rq-ws-ecleaner-prompt__add" type="button">Yes, add it</button>' +
        '</div>' +
      '</div>';
    wrap.appendChild(modal);
    injectStyles();
    return modal;
  }

  var stylesInjected = false;
  function injectStyles() {
    if (stylesInjected) return;
    stylesInjected = true;
    var css =
      '.rq-ws-ecleaner-prompt{position:fixed;inset:0;z-index:10000;display:flex;align-items:center;justify-content:center}' +
      '.rq-ws-ecleaner-prompt__backdrop{position:absolute;inset:0;background:rgba(0,0,0,0.4)}' +
      '.rq-ws-ecleaner-prompt__dialog{position:relative;width:440px;max-width:92vw;background:var(--rq-bg-surface);border:2px solid var(--rq-border);border-radius:12px;box-shadow:0 12px 36px rgba(0,0,0,0.22)}' +
      '.rq-ws-ecleaner-prompt__header{padding:14px 18px;border-bottom:1px solid var(--rq-border)}' +
      '.rq-ws-ecleaner-prompt__title{font-family:Montserrat,sans-serif;font-size:15px;font-weight:700;color:var(--rq-text);margin:0}' +
      '.rq-ws-ecleaner-prompt__body{padding:18px}' +
      '.rq-ws-ecleaner-prompt__msg{font-family:Montserrat,sans-serif;font-size:14px;color:var(--rq-text);margin:0 0 8px;line-height:1.5}' +
      '.rq-ws-ecleaner-prompt__hint{font-family:Montserrat,sans-serif;font-size:12px;color:var(--rq-text-secondary);margin:0;font-style:italic}' +
      '.rq-ws-ecleaner-prompt__footer{display:flex;justify-content:flex-end;gap:10px;padding:14px 18px;border-top:1px solid var(--rq-border)}';
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
  }

  function openPrompt(qty, ecoreTotal, onResolve) {
    var m = ensureModal();
    var msg = m.querySelector('.rq-ws-ecleaner-prompt__msg');
    var bottleWord = qty === 1 ? 'bottle' : 'bottles';
    msg.innerHTML =
      'This quote has <strong>' + ecoreTotal.toLocaleString() + '</strong> sq ft of ECORE flooring ' +
      'but no E-Cleaner (' + ECLEANER_SKU + '). ' +
      'Add <strong>' + qty + ' ' + bottleWord + '</strong>?';
    m.style.display = '';

    function cleanup() {
      m.style.display = 'none';
      addBtn.removeEventListener('click', onAdd);
      skipBtn.removeEventListener('click', onSkip);
      m.querySelector('.rq-ws-ecleaner-prompt__backdrop').removeEventListener('click', onSkip);
    }
    function onAdd() {
      var ok = addECleaner(qty);
      cleanup();
      if (!ok && Q.showToast) Q.showToast('E-Cleaner not found in catalog — saving without it.', 'warning');
      onResolve();
    }
    function onSkip() {
      cleanup();
      onResolve();
    }
    var addBtn = m.querySelector('.rq-ws-ecleaner-prompt__add');
    var skipBtn = m.querySelector('.rq-ws-ecleaner-prompt__skip');
    addBtn.addEventListener('click', onAdd);
    skipBtn.addEventListener('click', onSkip);
    m.querySelector('.rq-ws-ecleaner-prompt__backdrop').addEventListener('click', onSkip);
  }

  /**
   * Once-per-quote-per-context prompt. `context` is 'save' or 'download':
   *   - 'save'     — fires on the first save with ECORE flooring, never again
   *                  on subsequent saves of this quote (sticky across reloads
   *                  and revisions of the same ref).
   *   - 'download' — fires on the first Download PDF press, giving the rep
   *                  one last chance before the customer-facing send.
   * Both flags persist on workstation_meta and reset only on a fresh clone.
   *
   * Returns true if a prompt was shown (caller defers; modal will invoke
   * `then()` after rep choice). Returns false if no prompt needed (caller
   * proceeds immediately).
   */
  function maybePromptECleaner(context, then) {
    // Back-compat: old call sites passed only the callback. Default to 'save'.
    if (typeof context === 'function') { then = context; context = 'save'; }
    if (!Q.catalogReady) return false;
    if (state.items.length === 0) return false;
    var ecoreTotal = getECoreTotal();
    if (ecoreTotal <= 0) return false;
    if (hasECleaner()) return false;
    var flagKey = context === 'download' ? 'eCleanerPromptedOnDownload' : 'eCleanerPromptedOnSave';
    if (state[flagKey]) return false;
    state[flagKey] = true;
    state.dirty = true;
    var qty = bottleCount(ecoreTotal);
    openPrompt(qty, ecoreTotal, then);
    return true;
  }

  Q.maybePromptECleaner = maybePromptECleaner;
})();
